import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  NotificationManager,
  SessionStorageManager,
  SiteConfigManager,
  useApplicationState,
} from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES, paymentRoutes } from '@atlas/routing';

import { DEPOSIT_FAILED } from 'src/common/constants';
import { showAlternativeMethodsOrError } from 'src/common/Popup/alternativePaymentUtils';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { payment } = clientProfileRoutes;
const { deposit, transactionHistory } = paymentRoutes;

const parseDepositFailedData = value => {
  try {
    const parsedValue = JSON.parse(value);

    return {
      alternativePmEnabled: !!parsedValue?.alternativePmEnabled,
      pmId: parsedValue?.pmId,
    };
  } catch {
    return {
      alternativePmEnabled: !!value,
      pmId: value,
    };
  }
};

const useDepositFailedNotification = () => {
  const { authenticated, resolved } = useApplicationState();
  const history = useHistory();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!resolved || !authenticated) return;
    if (new URLSearchParams(search).get('deposit_failed') === 'true') return;

    const depositFailedData = SessionStorageManager.getItem(DEPOSIT_FAILED);
    if (depositFailedData === null) return;

    SessionStorageManager.removeItem(DEPOSIT_FAILED);

    if (pathname.includes(transactionHistory)) return;

    const { alternativePmEnabled, pmId } = parseDepositFailedData(depositFailedData);

    const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
    const depositPageLink = `${clientProfilePath}/${payment}/${deposit}`;

    const fallbackError = () => {
      NotificationManager.display({
        data: {
          className: 'deposit-failed-popup',
          headerTitle: 'deposit',
          text: 'deposit_failed_message',
          title: 'deposit_failed_title',
        },
        type: 'errorTransaction',
      });
    };

    if (!alternativePmEnabled) {
      fallbackError();
      return;
    }

    showAlternativeMethodsOrError({
      fallbackError,
      onSelectMethod: method => history.push(`${depositPageLink}/${method.id}`),
      onViewAll: () => history.push(depositPageLink, { showAllMethods: true }),
      operationType: 'DEPOSIT',
      pmId: Number(pmId),
    });
  }, [resolved, authenticated, history, pathname, search]);
};

export default useDepositFailedNotification;
